export const contractStatusMap = {
  incomplete: ['Incomplete', 'status-red', 'default'],
  draft: ['Draft', 'status-black', 'default'],
  not_spending: ['Not Spending', 'status-red', 'primary'],
  pre_launch: ['Pre Launch', 'status-green', 'primary'],
  questionable: ['Questionable', 'status-yellow', 'warning'],
  scheduled: ['Scheduled', 'status-green', 'primary'],
  spending: ['Spending', 'status-green', 'primary'],
  ended: ['Ended', 'status-black', 'default'],
};

export const contractFormText = {
  importButtonLabel: 'Import Settings From An Existing Contract',
  uploadIoButtonLabel: 'Upload IO',
  attributionUpload: 'Upload',
  attributionDownload: 'Download Templates',
  changelog: 'See Changelog',
  contractNewSave: 'Create Contract & Next',
  contractNewCancel: 'Cancel',
  contractEditDuplicate: 'Duplicate',
  contractEditVersion: 'Versions',
  contractEditNext: 'Next',
  contractEditSave: 'Save Contract',
  locationsTemplateLink:
    'https://s3-external-1.amazonaws.com/ventura-uploads/production/template_files/sample_attribution_locations.csv',
  locationsUploadTip: 'You will be able to upload locations once the contract has been created.',
  contractHeader: {
    new: 'Create New Contract',
    edit: 'Edit Contract',
    status: 'Status: ',
  },
  resumeAll: 'Resume All',
  pauseAll: 'Pause All',
  sectionTitles: {
    general: 'General',
    clientBilling: 'Client & Billing',
    reporting: 'Reporting',
    budgetRates: 'Budget & Rates',
    cpaSettings: 'CPA Settings',
    kpiSettings: 'Campaign Goals & KPIs',
  },
  subsectionTitles: {
    flightDates: 'Flight Dates',
    identification: 'Contract Identification (Optional)',
    billing: 'Billing',
    clientAndAd: 'Client & Advertiser',
    customBillingOptions: 'Custom Billing Options',
    budget: 'Budget',
    rate: 'Rate',
    attribution: 'Attribution Targets',
    cpaAction: 'CPA Action',
    bidSource: 'Bid Source',
    cap: 'Frequency & Performance Cap',
  },
  kpiSection: {
    addButton: '+ New KPI',
    kpiLabel: 'KPI',
    providerLabel: 'Provider (Optional)',
    goalLabel: 'Goal',
    emptyState: 'No KPIs added yet. Click "+ New KPI" to add campaign goals and success metrics.',
    requiredError: 'At least one KPI is required',
  },
};

export const contractFilterPivotMap = {
  accountManager: {
    title: 'Account Manager',
    description: 'Filter by Account Manager',
    filterName: 'account_manager',
    endpoint: `/admin/users/autocomplete_user_name?role=managers&term=`,
  },
  advertiser: {
    title: 'Advertiser Name',
    description: 'Filter by Advertiser Name',
    filterName: 'advertiser',
    endpoint: `/admin/advertisers/autocomplete_advertiser_name?term=`,
  },
  client: {
    title: 'Client Name',
    description: 'Filter by Client Name',
    filterName: 'client',
    endpoint: '/admin/clients/autocomplete_client_name?term=',
  },
  trafficker: {
    title: 'Trafficker',
    description: 'Filter by Trafficker',
    filterName: 'trafficker',
    endpoint: `/admin/users/autocomplete_user_name?term=`,
  },
};

export const contractDateFilterPivotMap = {
  start: {
    title: 'Io Start Date',
    description: 'Filter for Io Start Date between',
    filterName: 'io_start_date',
  },
  end: {
    title: 'Io End Date',
    description: 'Filter for Io End Date between',
    filterName: 'io_end_date',
  },
};

export const contractStepLabels = ['Contract Details', 'Contract Configuration', 'Contract Review'];
